import React from 'react';

const InfoTextStep = ({ question, onNext }) => {
  return (
    <div data-testid={`step-${question.id}`}>
      {/* Info Icon */}
      <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      
      {/* Title if exists */}
      {question.question && (
        <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-900 mb-4">
          {question.question}
        </h2>
      )}
      
      {/* Info Text */}
      <div className="bg-gray-50 rounded-xl p-6 mb-6">
        <p className="text-gray-700 whitespace-pre-line text-sm leading-relaxed">
          {question.infoText}
        </p>
      </div>
      
      {/* Continue Button */}
      <button
        onClick={onNext}
        className="btn-primary"
        data-testid="continue-button"
      >
        I Understand, Continue
      </button>
    </div>
  );
};

export default InfoTextStep;
